import React from 'react';
import SettingPasswordForm from './components/SettingPasswordForm';
import { useTranslation } from 'react-i18next';

const ChangePasswordPage = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="l-title-wrap">
        <h1 className="m-title-main">{t('features.Users.ChangePasswordPage.change_password')}</h1>
      </div>
      <div>
        <SettingPasswordForm />
      </div>
    </div>
  );
};

export default ChangePasswordPage;
